<template>
  <div class="offcanvas offcanvas-end" tabindex="-1" :id="offcanvas_id" data-bs-backdrop="static" :aria-labelledby="`${offcanvas_id}_label`">
    <div class="offcanvas-header">
      <button class="btn-back" type="button" name="button" data-test="btnCloseOffcanvas" data-bs-dismiss="offcanvas" aria-label="Close">
        <IconArrowBack/>
        {{ $t('goBack') }}
      </button>
      <h5 class="offcanvas-title d-block" :id="`${offcanvas_id}_label`">{{ title }}</h5>
    </div>
    <div class="offcanvas-body">
      <div class="loading-eye" v-show="imgSrc.loading"></div>
      <cropper ref="imgCrop" id="imgCrop" class="cropper" :class="{'min-height': imgSrc.loading}" :src="imgSrc.src" background-class="cropper__background"
                :stencil-props="cropperOptions" :minWidth="minWidth" :minHeight="minHeight" @ready="readyImg" @change="refreshCropper"/>

      <div v-if="errorMessage" class="alert alert-danger mt-3" role="alert">
        {{ errorMessage }}
      </div>

      <!-- footer inside body to avoid empty space between body and footer -->
      <div class="offcanvas-footer">
        <!-- <button type="button" class="btn" :class="cancelButtonClass" data-bs-dismiss="modal" v-show="cancelButton" data-test="btnCancelCropper" @click="doCancel">{{ cancelButton }}</button> -->
        <div v-show="!modalType">
          <label for="file-upload" class="btn btn-success">
            <i class="glyphicon glyphicon-upload"></i>
            {{ $t('clinic.selectFile') }}
          </label>
          <input id="file-upload" type="file" ref="fileInput" @change="changeImg" accept="image/*"/>
        </div>
        <button type="button" class="btn btn-danger" name="button"  @click="doRemove" v-show="removeButton && imgSrc.src" data-test="btnRemoveCropper">{{ $t('remove') }}</button>
        <button type="button" class="btn btn-primary" :class="okButtonClass" data-test="btnConfirmCropper" @click="doConfirm" :disabled="!canSave">{{ okButton }}</button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.offcanvas {
  // width:                                510px !important;
  // padding:                              40px;

  .offcanvas-header,
  .offcanvas-body {
    padding:                            0;
  }

  .offcanvas-header {
    display:                            block;
  }

  .offcanvas-title {
    color:                              var(--Brand-Primary, #1B294A);
    font-size:                          38px;
    font-weight:                        300;
    line-height:                        normal;
    margin:                             26px 0;
  }

  .offcanvas-body {
    p {
      color:                            var(--Brand-Primary, #1B294A);
      font-size:                        var(--font-size-14);
      font-weight:                      300;
      line-height:                      140%; /* 19.6px */
      margin-bottom:                    26px;
    }

    .loading-eyer {
      width:                            200px;
      height:                           200px;
      margin:                           0 auto;
      display:                          block;
    }

    .min-height {
      height:                           1px;
    }
  }

  .offcanvas-footer {
    display:                            flex;
    flex-direction:                     column;
    gap:                                26px;
    padding-top:                        26px;

    .btn {
      font-size:                        var(--font-size-14);
      font-weight:                      700;
      line-height:                      normal;
      letter-spacing:                   4.2px;
      text-align:                       center;
      text-transform:                   uppercase;
      // gap:                              10px;
      // flex:                             1 0 0;
      width:                            100%;
      padding:                          20px;
    }

    .btn-success {
      color:                            var(--Shades-W, #FFF);
      // margin-top:                       26px;
    }

    input[type="file"] {
      display:                          none;
    }
    label {
      margin:                           0;
    }
  }
}
</style>

<script>
import { Offcanvas } from 'bootstrap';

export default {
  name: 'BaseCropperOffcanvas',
  props: ['offcanvas_id'],
  data: () => ({
    bsOffcanvasInstance: null,
    modalType: null,
    title: null,
    imgSrc: {
      name: null,
      src: null,
      type: null,
      loading: false,
      isNew: false,
    },
    okButton: null,
    okButtonClass: null,
    removeButton: false,
    cancelButton: null,
    cancelButtonClass: null,
    cropperOptions: {
      class: 'cropper-background',
      aspectRatio: 2/1,
    },
    minWidth: 0,
    minHeight: 0,
    offcanvas_cropper: null,
    errorMessage: null,
    hasCropperBeenAdjusted: false,
    removeSignature: false,
    resolvePromise: null,
    rejectPromise: null,
  }),
  computed: {
    canSave() {
        return (!this.errorMessage && 
              (this.removeSignature || 
                this.imgSrc.isNew || 
                (this.imgSrc.src && this.hasCropperBeenAdjusted)));
    }

  },
  watch: {
    'imgSrc.src'(value) {
      console.log('watch', value);
      if (value) {
        this.imgSrc.loading = true;
        console.log('this.imgSrc.loading watch', this.imgSrc.loading);
        // let cropWidth = document.getElementById('imgCrop').innerWidth
        // console.log('cropWidth', cropWidth);
        // setTimeout(() => {
        //   this.imgSrc.loading = false
        // }, 1000)
      }
    }
  },
  mounted() {
    const offcanvasElement = document.getElementById(this.offcanvas_id);
    if (offcanvasElement) {
      // Initialize the bootstrap offcanvas instance only once
      this.bsOffcanvasInstance = new Offcanvas(offcanvasElement);

      offcanvasElement.addEventListener('shown.bs.offcanvas', this.onOffcanvasShown);
      offcanvasElement.addEventListener('hidden.bs.offcanvas', this.onOffcanvasHidden);
    }
  },
  beforeUnmount() {
    const offcanvasElement = document.getElementById(this.offcanvas_id);
    if (offcanvasElement) {
      offcanvasElement.removeEventListener('shown.bs.offcanvas', this.onOffcanvasShown);
      offcanvasElement.removeEventListener('hidden.bs.offcanvas', this.onOffcanvasHidden);
    }
    if (this.bsOffcanvasInstance) {
      this.bsOffcanvasInstance.dispose();
      this.bsOffcanvasInstance = null;
    }
  },

  methods: {
    show(options = {}) {
      this.resetState();

      this.modalType = options.modalType;
      this.title = options.title;
      this.imgSrc.src = options.imgSrc
      this.okButton = options.okButton;
      this.okButtonClass = options.okButtonClass;
      this.removeButton = options.removeButton;

      this.cropperOptions.aspectRatio = options.aspectRatio == null ? 2/1 : options.aspectRatio;
      this.minHeight = options.minHeight || 0;
      this.minWidth = options.minWidth || 0;

      if (this.bsOffcanvasInstance) {
        this.bsOffcanvasInstance.show();
      } else {
        console.error('Bootstrap Offcanvas instance not found. Make sure it is initialized in mounted().');
        return Promise.reject('Offcanvas not initialized.');
      }

      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve;
        this.rejectPromise = reject;
      });
    },

    resetState() {
      this.errorMessage = null;
      this.imgSrc.isNew = false;
      this.imgSrc.name = null;
      this.imgSrc.type = null;
      this.hasCropperBeenAdjusted = false;
      this.removeSignature = false;

      if (this.imgSrc.src && this.imgSrc.src.startsWith('blob:')) {
        URL.revokeObjectURL(this.imgSrc.src);
      }
      this.imgSrc.src = null;

      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = '';
      }
      this.cropperKey++;
    },

    doConfirm() {
      this.offcanvas_cropper = null;

      const result = this.saveImg();
      this.resolvePromise(result);
      
      this.closeOffCanvas();
    },

    doCancel() {
      this.offcanvas_cropper = null;
      this.resolvePromise(false)
      this.closeOffCanvas();
    },

    doRemove() {
      this.removeSignature = true;
      
      if (this.imgSrc.src && this.imgSrc.src.startsWith('blob:')) {
        URL.revokeObjectURL(this.imgSrc.src);
      }
      this.imgSrc.src = null;
      this.imgSrc.name = null;
      this.imgSrc.type = null;
    },
    closeOffCanvas() {
      if (this.bsOffcanvasInstance) {
        this.bsOffcanvasInstance.hide();
      }
      this.resetState();
    },
    refreshCropper() {
      this.loading = false

      if (this.loopCounter > 2) {
        return
      }
      this.loopCounter++;
      this.$refs.imgCrop.refresh();
      this.hasCropperBeenAdjusted = true;
    },

    changeImg(event) {
      const file = event.target.files[0]
      this.errorMessage = null;
      
      this.removeSignature = false;
      
      this.imgSrc.isNew = false;
      this.hasCropperBeenAdjusted = false;

      if (!file) {
        this.errorMessage = this.$i18n.t('clinic.noFileSelected');
        return;
      }

      if (!file.type.startsWith('image/')) {
        this.errorMessage = this.$i18n.t('clinic.fileNotAllowed');
        event.target.value = '';
        return;
      }

      this.imgSrc.name = file.name
      this.imgSrc.type = file.type
      this.imgSrc.src = URL.createObjectURL(file);
      this.imgSrc.isNew = true;
      this.hasCropperBeenAdjusted = true;

      if (!this.showSaveButton)
        this.showSaveButton = !this.showSaveButton;
    },

    saveImg() {
      NProgress.start();
      try {
        if (this.removeSignature) {
          return {
            removeSignature: 'yes',
            canvas: null
          };
        }

        if (!this.$refs.imgCrop || !this.imgSrc.src || (!this.imgSrc.isNew && !this.hasCropperBeenAdjusted)) {
          console.warn('Attempt to save without new image or valid adjustment in cropper.');
          NProgress.done(true);
          return {
            removeSignature: null,
            canvas: null
          };
        }
        
        const {canvas} = this.$refs.imgCrop.getResult();
        return {
          coordinates: this.$refs.imgCrop.getResult().coordinates,
          canvas: canvas,
          removeSignature: null
        };
      } catch (e) {
        console.error("err:", e);
        NProgress.done(true);
        return {
          removeSignature: null,
          canvas: null
        };
      } finally {
        NProgress.done(true);
        this.refreshCropper();
      }
    },

    readyImg() {
      console.log('READYYYYYYYYYYYYYY Image is successfully loaded');
      this.imgSrc.loading = false;
      console.log('this.imgSrc.loading ready', this.imgSrc.loading);
      this.hasCropperBeenAdjusted = false;
    }
  },
  unmounted() {
    this.cropperOptions.aspectRatio = 2/1
    this.imgSrc.src = null
    this.loopCounter = 0
  }
}
</script>
